import PrizmdocViewer from '../src/utils/prizmdoc/viewer'
import API from '../src/vue_shared/api'
import {
  setSaveBurnButtonEnabled,
  totalRedactionCount
} from '../src/utils/prizmdoc/saveBurnButton'

document.addEventListener('DOMContentLoaded', async () => {
  if (!document.querySelector('[data-prizmdoc-viewer]')) return

  const prizmdocViewer = await PrizmdocViewer(null)

  async function createPrizmdocViewer(el: HTMLElement): Promise<void> {
    const {
      returnUrl,
      documentId,
      documentFileExt,
      documentName,
      prettyId,
      redaction
    } = el.dataset

    // Get hybrid viewing setting from checkbox
    const hybridViewingCheckbox = document.getElementById(
      'enable-hybrid-viewing'
    ) as HTMLInputElement
    const enableHybridViewing = hybridViewingCheckbox?.checked || false

    const {
      data: { viewingSessionId }
    } = await API.newViewingSession(
      documentId,
      documentFileExt.slice(1),
      enableHybridViewing
    )

    // TODO: include more differences in arguments
    const redactionArgs = redaction
      ? {
          redactedDocumentName: `${documentName}-redacted.pdf`,
          redactedDocumentsPath: `/client/requests/${prettyId}/redacted_documents`
        }
      : {}
    const viewerControl = await prizmdocViewer(
      `#${el.id}`,
      viewingSessionId,
      documentName,
      redaction,
      null,
      {
        rapidReview: false,
        prettyId,
        documentId,
        returnUrl,
        ...redactionArgs
      }
    )

    if (redaction) {
      const updateSaveBurnButtonState = () => {
        setSaveBurnButtonEnabled(totalRedactionCount(viewerControl) > 0)
      }

      // Set the correct default immediately: no marks are loaded yet at this
      // point, so this disables the button until proven otherwise.
      updateSaveBurnButtonState()

      $(`#${el.id}`).on('ViewerReady', updateSaveBurnButtonState)
      viewerControl
        .on('MarkCreated', updateSaveBurnButtonState)
        .on('MarkRemoved', updateSaveBurnButtonState)
        .on('MarkChanged', updateSaveBurnButtonState)
    }

    // Set the redactionComments option when finalizing to remove comments.
    window.PCCViewer.Ajax.setOverrideMethod((options) => {
      if (
        options.method === 'POST' &&
        options.url.match(/\/ViewingSession\/.*\/MarkupBurner/g)
      ) {
        if (options.url.match(/.*\/MarkupBurner$/g)) {
          options.url += '?'
        } else {
          options.url += '&'
        }

        options.url += 'redactionComments=removeHidden'
      }
    })
  }

  const viewerPromises = []
  document
    .querySelectorAll('[data-prizmdoc-viewer]')
    .forEach((node: HTMLElement) =>
      viewerPromises.push(createPrizmdocViewer(node))
    )
  await Promise.all(viewerPromises)

  // Add event listener for hybrid viewing checkbox
  const hybridViewingCheckbox = document.getElementById(
    'enable-hybrid-viewing'
  ) as HTMLInputElement
  if (hybridViewingCheckbox) {
    hybridViewingCheckbox.addEventListener('change', async () => {
      const viewerEl = document.querySelector(
        '[data-prizmdoc-viewer]'
      ) as HTMLElement
      if (viewerEl) {
        viewerEl.innerHTML = ''
        await createPrizmdocViewer(viewerEl)
      }
    })
  }
})
